angular.module('picmonic-common').directive('plsRtSourcing', [
  'PresentationsService',
  'UserService',
  function (PresentationsService, UserService) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        // if update is needed see website/pages/events/presentation.tsx
        const params = new URLSearchParams({
          email: UserService.user.email ?? '',
          first_name: UserService.user.first_name ?? '',
          last_name: UserService.user.last_name ?? '',
          phone: UserService.user.phone ?? '',
          market: UserService.user.lead ?? '',
          Graduation_Year: UserService.user.graduation_year ?? '',
          Account_Name: UserService.user.school ? UserService.user.school.name : '',
        });

        const baseUrl =
          [101, 202, 203].indexOf(UserService.user.lead) !== -1
            ? 'https://content.truelearn.com/PicmonicPresentationFacultyIntro'
            : 'https://content.truelearn.com/PicmonicPresentationLearners';

        element.click(function () {
          window.open(baseUrl + '?' + params.toString(), '_blank');
        });
      },
    };
  },
]);
